import * as React from "react";
import "core-js/actual";
import { createRoot } from "react-dom/client";
import { FeatureToggleService } from "@piral/feature-management";
import { OpenCak } from "./render";
import env from "./env";
import { initializeRum } from "./initializeRum";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _paq: any[];
  }
}

if (env.RUM_ENABLED) {
  initializeRum({
    token: env.RUM_TOKEN,
    applicationName: "opencak",
    environment: env.RUM_DEPLOYMENT_ENV,
    version: env.BUILD_PCKG_VERSION
  });
}

const allFeatureToggleService = new FeatureToggleService(env.API ?? "");

(async () => {
  const allFeaturesToggleResult = await allFeatureToggleService.getAllFeatureToggles();
  const container = createRoot(document.getElementById("app")!);
  container.render(<OpenCak language="nl" allFeaturesToggle={allFeaturesToggleResult} />);
})();
